import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ContractFrequencyEnum, ContractsRuntimeDto, ContractsRuntimeGroupDto} from "../../types/contracts.types";
import {Router} from "@angular/router";


@Component({
  selector: 'app-contract-groups',
  templateUrl: './contract-groups.component.html',
  styleUrls: ['contract-groups.component.scss']
})
export class ContractGroupsComponent extends CoreComponent implements OnInit {

  @Input() contractFrequency: number = ContractFrequencyEnum.annually;
  @Input() contractsRuntime!: ContractsRuntimeDto;
  @Input() override busy: boolean = false;
  // @Output() onFrequencyChange: EventEmitter<ContractFrequencyEnum> = new EventEmitter<ContractFrequencyEnum>();
  @Output() showGroupChange = new EventEmitter<boolean>();
  showGroups: boolean = true;
  // contractFrequencyOptions: any[] = [
  //   {label: 'Jährlich', value: ContractFrequencyEnum.annually},
  //   {label: 'Monatlich', value: ContractFrequencyEnum.monthly}];
  // contractFrequency: number = ContractFrequencyEnum.annually;

  constructor(protected router: Router) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {
    this.initialized = true;
  }

  handleCarouselPageChange(event: any) {

  }

  showContractsForCategory(category: ContractsRuntimeGroupDto) {
    this.router.navigate(['/ds/contracts'], {queryParams: {categoryId: category.id}});
  }

  // handleFrequency() {
  //   this.onFrequencyChange.emit(this.contractFrequency);
  // }

  showContractDetail() {
    this.showGroups = !this.showGroups
    this.showGroupChange.emit(this.showGroups);
  }


}
